import RatingNReview from "../TalentInfo/RatingNReview";
import { useTheme, useMediaQuery } from "@mui/material";
import "./ReviewCard.scss";

export function ReviewCard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={`review-card-wrapper ${isMobile ? 'mobile' : ''}`}>
      <div className="review-card-header">
        <div className="reviewer-info">
          <div className="reviewer-profile">
            <img src="/assets/user.svg" alt="user-icon" />
            <span>John Doe</span>
          </div>
          <div className="timestamp">
            <RatingNReview rating="4.6" reviews="1 week ago" />
          </div>
        </div>
      </div>
      <div className="review-card-body">
        I was genuinely blown away by the music lesson I had with Jenny. Her
        incredible talent and engaging teaching style made the experience
        unforgettable. She was quick to answer my questions and communicated
        everything clearly, making the whole process enjoyable. I can't wait to
        have another lesson with her—definitely recommend! 🎶
      </div>
      <div className="review-card-footer">
        <img src="/assets/singer.svg" alt="user-icon" />
        <div className="review-card-footer-description">
          <p>
            Unlock Your Musical Potential: Mentorship for Aspiring
            Singer/Songwriters
          </p>
          <div className="badge-group">
            <div className="badge">Heart</div>
            <div className="chips">
              <img src="/assets/dollar.svg" alt="dollar-icon" />
              <span>100</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
